/**
 * @generated SignedSource<<2643aac59cb50a1e731b2c168a088377>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GeneratePortalUserInviteLinkInput = {
  clientOrgId: string;
  userId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type generatePortalUserInviteLinkMutation$variables = {
  input: GeneratePortalUserInviteLinkInput;
};
export type generatePortalUserInviteLinkMutation$data = {
  readonly generatePortalUserInviteLink: {
    readonly url: string | null;
    readonly expiresAt: string | null;
  } | null;
};
export type generatePortalUserInviteLinkMutation = {
  variables: generatePortalUserInviteLinkMutation$variables;
  response: generatePortalUserInviteLinkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GeneratePortalUserInviteLinkPayload",
    "kind": "LinkedField",
    "name": "generatePortalUserInviteLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "generatePortalUserInviteLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generatePortalUserInviteLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d42a69637fa037d34a3c21021674aa85",
    "id": null,
    "metadata": {},
    "name": "generatePortalUserInviteLinkMutation",
    "operationKind": "mutation",
    "text": "mutation generatePortalUserInviteLinkMutation(\n  $input: GeneratePortalUserInviteLinkInput!\n) {\n  generatePortalUserInviteLink(input: $input) {\n    url\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "370f1decb350a181916d5e65adb408db";

export default node;
